import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { takeListPromotion, editPromotion } from '../../api/other/promotion'
import { errorToast, informationToast, } from '../../utils/Toast/index'; //warningToast, 

function PromotionContainer() {
    const [promotions, setPromotions] = useState([]);
    const auth = useSelector(state => state.auth);
    const { user } = auth;
    const { branchID } = user;
    const token = useSelector(state => state.token);
    const [selected,setSelected] = useState(null);

    const days = ["mon","tue","wed","thu","fri","sat","sun"];

    function update(field,value){
        setSelected({...selected,[field]:value});
    }

    function toggleDay(day){
        let arr=[...selected.days];

        if(arr.includes(day))
        arr=arr.filter(d=>d!==day);
        else
        arr.push(day);

        update("days",arr);
    }

    function save(){

        setPromotions(p=>p.map(x=>x._id===selected._id?selected:x));

        const onSavePromotion = async () => {
            const dataSave = await editPromotion(branchID, selected, token);

            if(dataSave) {
                if(dataSave.data.status === 1) {
                    informationToast(dataSave.data.msg)
                } else errorToast("Error when save promotion")
            } else errorToast("Error when save promotion")
            
        }

        onSavePromotion();
    }

    // function handleChange(field,value){
    // setSelected({
    // ...selected,
    // [field]:value
    // });
    // }
    
    // function handleChange(field,value){
    // setSelected({
    // ...selected,
    // [field]:value
    // });
    // }

    // function savePromotion(){
    //     setPromotions(prev =>
    //     prev.map(p =>
    //     p._id === selected._id ? selected : p
    //     )
    //     );

    //     // ở đây bạn có thể call API update
    //     // await axios.put("/promotion",selected)

    //     alert("Saved!");
    // }
    function formatDate(date){
        return new Date(date).toISOString().split("T")[0];
    }


    useEffect(() => {
        const loadPromotion = async () => {
          const dataPromotion = await takeListPromotion(branchID, token);
          console.log("dataPromotion", dataPromotion.data)
          setPromotions(dataPromotion.data.data)
          informationToast(dataPromotion.data.msg)
        }

        if(branchID) loadPromotion()

    },[branchID, token])
    
    return (
        <>
            <style>{`

            body{
            background:#f4f6f9;
            }

            .container{
            display:flex;
            height:100vh;
            font-family:Arial;
            }

            .left{
            width:50%;
            border-right:1px solid #ddd;
            overflow:auto;
            background:white;
            }

            .right{
            width:50%;
            padding:30px;
            overflow:auto;
            }

            .item{
            padding:15px;
            border-bottom:1px solid #eee;
            cursor:pointer;
            transition:0.2s;
            }

            .item:hover{
            background:#f7f9fc;
            }

            .active{
            background:#e6f4ff;
            }

            .title{
                font-weight:bold;
                font-size: 1.5rem
            }

            .description {
                font-size: 1.3rem
            }

            .badge{
                background:#ff4d4f;
                color:white;
                padding:3px 7px;
                border-radius:5px;
                font-size:12px;
                display:inline-block;
                margin-top:5px;
            }

            .card{
                background:white;
                padding:25px;
                border-radius:10px;
                box-shadow:0 2px 10px rgba(0,0,0,0.05);
            }

            .field{
                margin-bottom:15px;
            }

            label{
            display:block;
            font-weight:600;
            margin-bottom:4px;
            }

            input,select,textarea{
            width:100%;
            padding:8px;
            border:1px solid #ddd;
            border-radius:6px;
            }

            textarea{
            height:70px;
            }

            .days{
            display:flex;
            flex-wrap:wrap;
            gap:6px;
            }

            .day{
            padding:6px 10px;
            border-radius:6px;
            border:1px solid #ccc;
            cursor:pointer;
            font-size:13px;
            }

            .day.active{
            background:#1677ff;
            color:white;
            border:none;
            }

            .rooms{
            display:flex;
            gap:6px;
            flex-wrap:wrap;
            }

            .room{
            background:#f0f2f5;
            padding:5px 8px;
            border-radius:6px;
            font-size:12px;
            }

            .save{
            margin-top:15px;
            background:#1677ff;
            color:white;
            border:none;
            padding:10px 16px;
            border-radius:6px;
            cursor:pointer;
            font-weight:bold;
            }

            .save:hover{
            background:#0958d9;
            }

            `}</style>


            <h1>MANAGE PROMOTION</h1>
            <div className="container">
                {/* LEFT LIST */}

                <div className="left">

                {promotions.map(p=>(
                <div
                key={p._id}
                className={`item ${selected?._id===p._id?"active":""}`}
                onClick={()=>setSelected({...p})}
                >

                <div className="title">{p.title}</div>

                <div  className="description">{p.description}</div>

                <div>Start date : {formatDate(p.startDate)} - End date : {formatDate(p.endDate)}</div>
                <div className="badge">
                    {p.discountValue} {p.type}
                </div>

                </div>
                ))}

                </div>


                {/* RIGHT DETAIL */}
                <div className="right">

                {!selected && <div>Select promotion</div>}

                {selected && (

                <div className="card">

                <div className="field">
                    <label>Title</label>
                    <input
                    value={selected.title}
                    onChange={e=>update("title",e.target.value)}
                    />
                </div>

                <div className="field">
                <label>Description</label>
                <textarea
                value={selected.description}
                onChange={e=>update("description",e.target.value)}
                />
                </div>

                <div className="field">
                    <label>Code</label>
                    <input
                    value={selected.code}
                    onChange={e=>update("code",e.target.value)}
                    />
                </div>

                <div className='d-flex'>
                    <div className="field" style={{width:"50%"}}>
                        <label>Discount</label>
                        <input
                        type="number"
                        value={selected.discountValue}
                        onChange={e=>update("discountValue",e.target.value)}
                        />
                    </div>

                    <div className="field" style={{width:"50%"}}>
                        <label>Type</label>
                        <select
                        value={selected.type}
                        onChange={e=>update("type",e.target.value)}
                        >
                            <option value="percent">percent</option>
                            <option value="fixed">fixed</option>
                            <option value="special">special</option>
                        </select>
                    </div>
                </div>

                <div className='d-flex'>
                    <div className="field" style={{width:"50%"}}>
                        <label>Start</label>
                        <input
                            type="date"
                            value={formatDate(selected.startDate)}  
                            onChange={e=>update("startDate",e.target.value)}
                        />
                    </div>

                    <div className="field" style={{width:"50%"}}>
                    <label>End</label>
                        <input
                            type="date"
                            value={formatDate(selected.endDate)}  
                            onChange={e=>update("endDate",e.target.value)}
                        />
                    </div>
                </div>

                <div className="field">
                    <label>Days</label>

                    <div className="days">
                        {days.map(d=>(
                        <div
                            key={d}
                            className={`day ${selected.days.includes(d)?"active":""}`}
                            onClick={()=>toggleDay(d)}
                            >
                            {d}
                        </div>
                        ))}
                    </div>
                </div>

                <div className="field">
                    <label>Room Types</label>
                    <div className="rooms">
                    {selected.roomTypes.map(r=>(
                    <div key={r} className="room">{r}</div>
                    ))}
                    </div>
                </div>

                <div className="field">
                    <label>Target Customer</label>
                    <select
                        value={selected.targetCustomer}
                        onChange={e=>update("targetCustomer",e.target.value)}
                        >

                        <option value="all">all</option>
                        <option value="vietnamese">vietnamese</option>
                        <option value="japanese">japanese</option>
                        <option value="foreign">foreign</option>
                    </select>
                </div>

                <button className="save" onClick={save}>
                  Save Promotion
                </button>

                </div>

                )}

                </div>
                </div>

        </>
    )
}

export default PromotionContainer;
